import type { QuestionProps } from "../../../../../components/Questionnaire/Section/Question/types";

type FilterAndAppendQuestionsParams = {
  existingQuestions: QuestionProps[];
  filteredQuestionNames: string[];
  newQuestions: QuestionProps[];
  allNewQuestionNames: string[];
};

/**
 * Filters existing questions and appends new questions.
 * Removes questions that are being replaced or are part of the new flattened payload.
 */
export const filterAndAppendQuestions = ({
  existingQuestions,
  filteredQuestionNames,
  newQuestions,
  allNewQuestionNames,
}: FilterAndAppendQuestionsParams): QuestionProps[] => {
  return [
    ...existingQuestions.filter(
      q =>
        filteredQuestionNames.includes(q.name) &&
        !allNewQuestionNames.includes(q.name),
    ),
    ...newQuestions,
  ];
};
